import { Grid, Stack, Badge, Divider, Switch, Slider, Autocomplete } from "@mui/material";
import { useMaterialUIController } from "context";
import { PermissionType } from "models/BO/BoRole";
import { Ticket, TicketPriority } from "models/customer-supports/Ticket";
import { TicketTopic } from "models/customer-supports/TicketTopic";
import { Introduction } from "models/introduction/Introduction";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getIntroductionDO } from "utils/introductionUtils";
import { PageNumber } from "../../../../accessNumbers";
import { numbers } from "utils/globalsUtils";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";

const MDTypography = require("components/MDTypography").default;

const MDInput = require("components/MDInput").default;

export const ReportImagesSection = ({
  ticket,
  userData,
  reporteeData,
  updateTicket,
}: {
  ticket: Ticket;
  userData: any;
  reporteeData: any;
  updateTicket: any;
}) => {
  const pageNumber = PageNumber.CustomerSupportTicketView;
  const [controller, dispatch] = useMaterialUIController();
  const { currentRole } = controller;
  // const [introduction, setIntroduction] = useState(null as Introduction | null);

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (ticket.introductionId) {
  //     getIntroductionDO(ticket.introductionId).then((data) => {
  //       setIntroduction(data);
  //     });
  //   }
  // }, [ticket.introductionId]);

  return (
    <Grid flexDirection="row" container alignItems={"end"} justifyContent="center" sx={{ px: 4 }}>
      <Grid
        sx={{ my: 2 }}
        flexWrap="nowrap"
        flexDirection="row"
        container
        gap={3}
        size={{
          xs: 5.8,
          lg: 5.8
        }}>
        <Stack direction="row">
          <Badge overlap="circular" anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
            <img
              src={userData?.avatar}
              style={{
                height: "84px",
                width: "84px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </Badge>
        </Stack>
        <Grid
          container
          display="flex"
          flexDirection="row"
          justifyContent="start"
          alignContent="center"
        >
          <MDTypography variant="h5" fontWeight="medium">
            Reporter:
          </MDTypography>
          <MDTypography variant="title" color="inherit" noWrap>
            &nbsp;
          </MDTypography>
          {userData?.firstName ? (
            <MDTypography
              variant="h5"
              fontWeight="light"
              onClick={() => navigate(`/endUsers/${userData?.id}`)}
              sx={{ color: "#49AAEF", cursor: "pointer" }}
            >
              {`${userData?.firstName} ${userData?.lastName ? userData?.lastName : ""}`}
            </MDTypography>
          ) : null}
        </Grid>
      </Grid>
      <Grid
        // flexWrap="nowrap"
        // flexDirection="row"
        // container
        // gap={3}
        sx={{ my: 2 }}
        size={{
          xs: 0.2,
          lg: 0.2
        }}>
        <Divider orientation="vertical" sx={{ bgcolor: "black" }} flexItem />
      </Grid>
      <Grid
        sx={{ my: 2 }}
        flexWrap="nowrap"
        flexDirection="row"
        container
        gap={3}
        size={{
          xs: 5.8,
          lg: 5.8
        }}>
        {reporteeData?.id ? (
          <>
            <Stack direction="row">
              <Badge overlap="circular" anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
                <img
                  src={reporteeData?.avatar}
                  style={{
                    height: "84px",
                    width: "84px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
              </Badge>
            </Stack>
            <Grid
              container
              display="flex"
              flexDirection="row"
              justifyContent="start"
              alignContent="center"
            >
              <MDTypography variant="h5" fontWeight="medium">
                Reportee:
              </MDTypography>
              <MDTypography variant="title" color="inherit" noWrap>
                &nbsp;
              </MDTypography>
              {userData?.firstName ? (
                <MDTypography
                  variant="h5"
                  fontWeight="light"
                  onClick={() => open(`#/endUsers/${reporteeData?.id}`, "_blank")}
                  sx={{ color: "#49AAEF", cursor: "pointer" }}
                >
                  {`${reporteeData?.firstName} ${
                    reporteeData?.lastName ? reporteeData?.lastName : ""
                  }`}
                </MDTypography>
              ) : null}
            </Grid>
          </>
        ) : null}
        {ticket.introductionId ? (
          <Grid
            container
            display="flex"
            flexDirection="row"
            justifyContent="start"
            alignContent="center"
          >
            <MDTypography variant="h5" fontWeight="medium">
              Introduction:
            </MDTypography>
            <MDTypography variant="title" color="inherit" noWrap>
              &nbsp;
            </MDTypography>
            <MDTypography
              variant="h5"
              fontWeight="light"
              onClick={() => open(`#/introductions/${ticket.introductionId}`, "_blank")}
              sx={{ color: "#49AAEF", cursor: "pointer" }}
            >
              {ticket.introductionId}
            </MDTypography>
          </Grid>
        ) : null}
        {ticket.topicId == 65 && [
          <Grid container display="flex" flexDirection="column" key="approvedByClient">
            <MDTypography variant="h5">Approved By ZUUG:</MDTypography>
            <Switch
              checked={ticket.extra?.approvedByClient}
              onChange={() =>
                updateTicket({
                  extra: { ...ticket.extra, approvedByClient: !ticket.extra?.approvedByClient },
                })
              }
            />
          </Grid>,
          currentRole.hasAccess(pageNumber, PermissionType.Manager) && [
            <Grid container display="flex" flexDirection="column" key="approvedByAdmin">
              <MDTypography variant="h5">Approved By Algo:</MDTypography>
              <Switch
                checked={ticket.extra?.approvedByAdmin}
                onChange={() =>
                  updateTicket({
                    extra: { ...ticket.extra, approvedByAdmin: !ticket.extra?.approvedByAdmin },
                  })
                }
              />
            </Grid>,
            <Grid container display="flex" flexDirection="column" key="devHours">
            <MDInput
              label="Dev Hours"
              type="number"
              
              value={ticket.extra?.devHours}
              onChange={(e) =>
                updateTicket({
                  extra: { ...ticket.extra, devHours: parseInt(e.target.value) },
                })
              }
            />
            
          </Grid>
          ],
          
        ]}
        <Grid container display="flex" flexDirection="column" key="priority" style={{width: "150px"}}>
        <Autocomplete
          options={numbers(TicketPriority)}
          fullWidth
          value={ticket.priority || TicketPriority.Default}
          getOptionLabel={(option) =>
            option + " - " + camelCaseToCapitalizedWords(TicketPriority[option])
          }
          renderInput={(params) => <MDInput {...params} label="Priority" />}
          onChange={(e, value) => {
            updateTicket({
              priority: value,
            });
          }}
        />
          </Grid>
      </Grid>
    </Grid>
  );
};
